<div class="modal-header ">
    <h4 class="modal-title header-5">
        {{ configs.title }}
    </h4>
   <button
      type="button"
      class="accello-icon-btn"
      (mousedown)="isActive = true"
      (mouseup)="isActive = false"
      (mouseleave)="isActive = false"
      (click)="activeModal.dismiss('Cross click')"
    >
      <img
        [src]="
          isActive
            ? 'assets/images/virtusa-icons/close-dark.svg'
            : 'assets/images/virtusa-icons/close.svg'
        "
        alt="Close"
      />
    </button></div>

<div class="modal-body agent-modal">
    <app-dynamic-form [form]="dynamicForm" [formFields]="fields" ></app-dynamic-form>
</div>

<div class="modal-footer">
    <div class="d-flex justify-content-end">
        <button class=" btn-accello-secondary mx-2" (click)="activeModal.dismiss('Cross click')"> Cancel </button>
        <button class=" btn-accello-primary-light" (click)="submit()" [disabled]="!dynamicForm.valid"> {{ configs?.saveBtnText ? configs.saveBtnText : 'Add' }} </button>
    </div>
</div>